import React, { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Grid, Tooltip } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid, SCUIGeneralDrawer } from '../../atomic/molecules';
import { CustomerQuery } from '../../services/query';
import { useTranslation } from 'react-i18next';
import { SCUIRptTopicManagementDrawerContent } from './components/SCUIRptTopicManagementDrawerContent';
import { SCUIButton } from '../../atomic/atoms';
import TimeHelper from '../../utils/time';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddIcon from '@mui/icons-material/Add';
import { IconButton } from '@mui/material';
import Swal from 'sweetalert2';
import { CustomerCommand } from '../../services/command';
import { RTM } from './rptTopicManagement.classes';

export const RptTopicManagement: FC<any> = () => {
    const { t } = useTranslation();
    const [state, setState] = React.useState({
        right: false,
    });
    const [getRptTopics, setRptTopics] = React.useState([]);
    const [rptTopic, setRptTopic] = React.useState<any>();
    const onDrawerOpen = () => setState({ ...state, right: true });
    const onDrawerClose = () => setState({ ...state, right: false });
    const [refresh, setRefresh] = useState(false);

    const refreshSmsTemplate = () => {
        setRefresh((prevLoading) => !prevLoading);
    };

    useEffect(() => {
        GetRptTopic();
    }, [refresh]);

    const columns: ExtendedGridColDef[] = [
        {
            field: 'topicName',
            headerName: t('rptTopic.topicName'),
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params: any) => {
                return (
                    <div className={RTM.cellTopicNameWrap}>
                        <Tooltip className={RTM.cellTopicNameTooltip} title={params.row.topicName}>
                            <p className={RTM.cellTopicNameText}>{params.row.topicName}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'topicControlDays',
            headerName: t('rptTopic.topicControlDays'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'updatedBy',
            headerName: t('rptTopic.updatedBy'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'updateDate',
            headerName: t('rptTopic.updatedDate'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'düzenle',
            headerName: t('general.edit'),
            width: 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    setRptTopic(params.row);
                    onDrawerOpen();
                };
                return (
                    <Tooltip title={t('general.edit')} placement="top" arrow>
                        <IconButton
                            size="small"
                            onClick={onclick}
                            className={RTM.cellEditButton}
                            sx={{
                                color: 'primary.main',
                                transition: 'all 0.2s ease',
                                '&:hover': { backgroundColor: 'rgba(25,118,210,0.08)' },
                            }}
                        >
                            <EditOutlinedIcon className={RTM.cellEditIcon} sx={{ fontSize: 18 }} />
                        </IconButton>
                    </Tooltip>
                );
            },
        },
        {
            field: 'sil',
            headerName: t('general.delete'),
            width: 70,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const onclick = () => {
                    console.info(params);
                    sil(params.row.id);
                };
                return (
                    <Tooltip title={t('general.delete')} placement="top" arrow>
                        <IconButton
                            size="small"
                            onClick={onclick}
                            className={RTM.cellDeleteButton}
                            sx={{
                                color: 'error.main',
                                transition: 'all 0.2s ease',
                                '&:hover': { backgroundColor: 'rgba(211,47,47,0.08)' },
                            }}
                        >
                            <DeleteOutlineIcon className={RTM.cellDeleteIcon} sx={{ fontSize: 18 }} />
                        </IconButton>
                    </Tooltip>
                );
            },
        },
    ];
    const sil = async (params: any) => {
        const result = await Swal.fire({
            text: t('mobilePanel.deleteConfig'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.delete'),
        });

        if (!result.isConfirmed) {
            return;
        }

        try {
            await CustomerCommand.DeleteRptTopic(params);
            await Swal.fire('Silindi!', ' ', 'success');
            refreshSmsTemplate();
        } catch (error: any) {
            console.log('Hata :>> ', error);
        }
    };
    const GetRptTopic = () => {
        CustomerQuery.GetRptTopic()
            .then((res: any) => {
                if (res) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            id: item.rptTopicId,
                            topicName: item.topicName || '-',
                            topicControlDays: item.topicControlDays || '-',
                            updatedBy: item.updatedBy || '-',
                            updateDate: (item.updateDate && TimeHelper.formatDate(item.updateDate)) || '-',
                        };
                    });
                    setRptTopics(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };

    return (
        <SCUIContent className={RTM.page}>
            <Grid
                className={RTM.titleRow}
                size={{
                    lg: 10,
                    md: 12,
                    xs: 12,
                }}
            >
                <h1 className={['headtxt', RTM.title].filter(Boolean).join(' ')}>{t('rptTopic.rptTopicManagement')}</h1>
            </Grid>
            <Grid
                className={RTM.actionsRow}
                container
                justifyContent="flex-end"
                size={{
                    xs: 12,
                    sm: 12,
                }}
            >
                <SCUIButton
                    className={RTM.createButton}
                    text={t('rptTopic.createRptTopic')}
                    sizeType="fixed"
                    type="primary"
                    size={'s'}
                    showStartIcon
                    startIcon={<AddIcon style={{ fontSize: '15px' }} />}
                    style={{ borderRadius: '8px', fontWeight: 600, fontSize: '12px' }}
                    onClick={() => {
                        setRptTopic([]);
                        onDrawerOpen();
                    }}
                ></SCUIButton>
            </Grid>
            <SCUIGeneralDrawer
                open={state['right']}
                anchor="right"
                width={360}
                paperClassName={RTM.drawerPaper}
                onClose={(event: any, reason: any) => {
                    if (reason === 'backdropClick') {
                        setState({ ...state, right: false });
                    }
                }}
            >
                <div className={RTM.drawerContent}>
                    <SCUIRptTopicManagementDrawerContent
                        selectedRow={rptTopic}
                        onCloseMenu={onDrawerClose}
                        onUpdate={refreshSmsTemplate}
                    />
                </div>
            </SCUIGeneralDrawer>
            <div className={RTM.dataGridWrap}>
                <SCUICustomDataGrid randomId rows={getRptTopics} columns={columns} />
            </div>
        </SCUIContent>
    );
};
